import { render, staticRenderFns } from "./LandingPage.vue?vue&type=template&id=3609ceea&scoped=true"
import script from "./LandingPage.js?vue&type=script&lang=js&external"
export * from "./LandingPage.js?vue&type=script&lang=js&external"
import style0 from "./LandingPage.vue?vue&type=style&index=0&id=3609ceea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3609ceea",
  null
  
)

export default component.exports